import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin( ScrollTrigger );

let
	mediaQuery = window.matchMedia( '(min-width: 1024px)' ),
	components,
	eventElements;

function initUpcomingEvents() {

	components    = document.querySelectorAll( '.c-upcoming-events' ),
	eventElements = document.querySelectorAll( '.c-upcoming-event' );

        if(eventElements) {
	eventElements.forEach( eventElement => {
		eventElement
			.querySelector( '.c-upcoming-event_toggle' )
			.addEventListener( 'click', event => {
				'false' === event.target.getAttribute( 'aria-expanded' )
					? openEvent( event.target.getAttribute( 'aria-controls' ) )
					: closeEvent( event.target.getAttribute( 'aria-controls' ) );
			});

		closeEvent( eventElement.querySelector( '.c-upcoming-event_content' ).id );
	});
        }

	try {		
		new Swiper( '.c-upcoming-events .swiper-container', {
			loop: false,
			slidesPerView: 1,
			spaceBetween: 0,			
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			on: {
				init: function () {
					if (this.slides.length <= 1) {
						
						this.allowSlidePrev = this.allowSlideNext = false; // disabling swiping
						if (this.el.querySelector(".swiper-button-prev"))
                                                  this.el.querySelector(".swiper-button-prev").setAttribute('hidden', '');  // hiding arrows prev&next
						if (this.el.querySelector(".swiper-button-prev"))
                                                  this.el.querySelector(".swiper-button-next").setAttribute('hidden', '');  // hiding arrows prev&next
					}
				}
			}					
		});
		
		
	} catch(e) {
		console.log(e.message);
	}

	if( ! window.matchMedia('(prefers-reduced-motion: reduce)').matches ) {
		initAnimations();
	}
}

function openEvent( id ) {
	let
		content   = document.getElementById( id ),
		component = content.parentElement,
		toggle    = component.querySelector( '[aria-controls="' + id + '"]'),
		startingHeight,
		naturalHeight;

	content.setAttribute( 'aria-hidden', false );
	toggle.setAttribute( 'aria-expanded', true );

	component.querySelectorAll('[tabindex]').forEach( tabbable => {
		tabbable.setAttribute( 'tabindex', '' );
	});

	startingHeight = component.clientHeight;
	component.style.height = 'auto';
	naturalHeight = component.clientHeight;

	gsap.set( component, { height: startingHeight + 'px' } );
	gsap.to( component, { duration: .5, height: naturalHeight + 'px' } );
}

function closeEvent( id ) {
	let
		content   = document.getElementById( id ),
		component = content.parentElement,
		toggle    = component.querySelector( '[aria-controls="' + id + '"]');

	content.setAttribute( 'aria-hidden', true );
	toggle.setAttribute( 'aria-expanded', false );

	component.querySelectorAll('[tabindex]').forEach( tabbable => {
		tabbable.setAttribute( 'tabindex', ' -1' );
	});

	gsap.to( component, {
		duration: .5,
		height: mediaQuery.matches ? '200px' : '201px' // dt : mb
	});
}

function initAnimations() {
	components.forEach( component => {
		let
			trigger     = component.querySelector( '.c-upcoming-events_list' ),
			animatables = component.querySelectorAll( '.c-upcoming-event > div' );

		gsap.set( animatables, {
			translateY: '100px'
		});

		gsap.timeline({
			scrollTrigger: {
				trigger: trigger,
				scrub: 1,
				start: 'top bottom',
				end: 'bottom-=50% top+=50%'
			}
		})
		.to( animatables, {
			keyframes: [
				{ duration: 1, translateY: '0px' },
			]
		});
	});
}

export {initUpcomingEvents};
